// src/pages/footer/terms.tsx
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useBrandConfig } from "@/hooks/use-brand-config";

export default function Terms() {
  const { brandConfig } = useBrandConfig();

  return (
    <div className="container mx-auto py-6">
      <Card>
        <CardHeader>
          <CardTitle>Terms of Service</CardTitle>
        </CardHeader>
        <CardContent className="prose">
          <p className="text-muted-foreground mb-6">
            Last updated: {brandConfig.legal.termsOfServiceLastUpdated}
          </p>

          <div className="space-y-6">
            <section>
              <h2 className="text-xl font-semibold mb-3">
                Acceptance of Terms
              </h2>
              <p>
                By accessing and using the {brandConfig.appName} service, you
                accept and agree to be bound by the terms and provision of this
                agreement.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">Use License</h2>
              <p>
                Permission is granted to temporarily download one copy of the
                materials on {brandConfig.company.name}'s website for personal,
                non-commercial transitory viewing only. This is the grant of a
                license, not a transfer of title, and under this license you may
                not:
              </p>
              <ul className="list-disc pl-6 mt-2">
                <li>modify or copy the materials</li>
                <li>
                  use the materials for any commercial purpose or for any public
                  display (commercial or non-commercial)
                </li>
                <li>
                  attempt to decompile or reverse engineer any software
                  contained on {brandConfig.company.name}'s website
                </li>
                <li>
                  remove any copyright or other proprietary notations from the
                  materials
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">
                Service Description
              </h2>
              <p>
                {brandConfig.appName} provides Google Ads optimization and
                analysis services through our web application. Our service
                includes:
              </p>
              <ul className="list-disc pl-6 mt-2">
                <li>Analysis of your Google Ads campaign data</li>
                <li>AI-powered insights and recommendations</li>
                <li>Educational content and tutorials</li>
                <li>Data visualization and reporting tools</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">
                User Responsibilities
              </h2>
              <p>As a user of our service, you agree to:</p>
              <ul className="list-disc pl-6 mt-2">
                <li>
                  Provide accurate and complete information when using our
                  service
                </li>
                <li>Maintain the security of your account credentials</li>
                <li>
                  Use the service in compliance with all applicable laws and
                  regulations
                </li>
                <li>
                  Not attempt to gain unauthorized access to our systems or
                  other users' data
                </li>
                <li>
                  Not use the service for any illegal or unauthorized purpose
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">Data and Privacy</h2>
              <p>
                Your privacy is important to us. Please review our Privacy
                Policy, which also governs your use of the service, to
                understand our practices regarding your data.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">Disclaimers</h2>
              <p>
                The materials on {brandConfig.company.name}'s website are
                provided on an 'as is' basis. {brandConfig.company.name} makes
                no warranties, expressed or implied, and hereby disclaims and
                negates all other warranties including without limitation,
                implied warranties or conditions of merchantability, fitness for
                a particular purpose, or non-infringement of intellectual
                property or other violation of rights.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">Limitations</h2>
              <p>
                In no event shall {brandConfig.company.name} or its suppliers be
                liable for any damages (including, without limitation, damages
                for loss of data or profit, or due to business interruption)
                arising out of the use or inability to use the materials on{" "}
                {brandConfig.company.name}'s website, even if{" "}
                {brandConfig.company.name} or a {brandConfig.company.name}{" "}
                authorized representative has been notified orally or in writing
                of the possibility of such damage. Because some jurisdictions do
                not allow limitations on implied warranties, or limitations of
                liability for consequential or incidental damages, these
                limitations may not apply to you.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">
                Revisions and Errata
              </h2>
              <p>
                The materials appearing on {brandConfig.company.name}'s website
                could include technical, typographical, or photographic errors.{" "}
                {brandConfig.company.name} does not warrant that any of the
                materials on its website are accurate, complete, or current.{" "}
                {brandConfig.company.name} may make changes to the materials
                contained on its website at any time without notice. However{" "}
                {brandConfig.company.name} does not make any commitment to
                update the materials.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">
                Contact Information
              </h2>
              <p>
                For questions about these Terms of Service, please contact us
                at:
                <br />
                {brandConfig.company.supportEmail}
              </p>
            </section>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
